// extracted by mini-css-extract-plugin
export default {"container":"table_container__+JtjH","team":"table_team__26uaN"};